export default class UserInputValidator
{
    protected target: HTMLElement;

    constructor (target: HTMLElement)
    {
        this.target = target;
    }

    public numeric()
    {
        let item = this.getCorrectTarget();
        if (item === null) {
            console.error('InputValidator: target is not an INPUT or TEXTAREA');
            return;
        }

        this.target.addEventListener('input', () => this.numericValues(item));
    }

    protected numericValues(item: HTMLInputElement|HTMLTextAreaElement)
    {
        let digitParts = [];
        let separator  = '';

        if (item.value.search(/(\.|,)/) !== -1) {
            separator = item.value.match(/(\.|,)/)[1];
        }

        let preg = new RegExp(`[^\\d${separator}]`, 'g');
        item.value.split(/[,.]/).forEach((part) => {
            digitParts.push(part.replace(preg, ''));
        });

        let decimal = digitParts.splice(1, digitParts.length - 1).join('');
        digitParts.push(decimal);

        let newVal = digitParts.join(separator);
        let caret = item.value.length > newVal.length ? item.selectionStart - 1 : item.selectionStart;

        item.value = newVal;
        item.setSelectionRange(caret, caret);
    }

    /**
     * @return HTMLTextAreaElement|HTMLInputElement|null
     */
    protected getCorrectTarget()
    {
        let item = null;

        switch (this.target.tagName) {
            case 'INPUT':
                item = this.target as HTMLInputElement;
                break;
            case 'TEXTAREA':
                item = this.target as HTMLTextAreaElement;
                break;
        }

        return item;
    }
}
